'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadScript;

var _logger = require('./logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function loadScript(_ref, callback) {
  var src = _ref.src,
      id = _ref.id,
      globalName = _ref.globalName,
      globalNames = _ref.globalNames,
      stubType = _ref.stubType,
      stubMethods = _ref.stubMethods,
      _ref$stub = _ref.stub,
      stub = _ref$stub === undefined ? null : _ref$stub,
      window = _ref.window,
      document = _ref.document;

  var script = document.createElement('script');
  var first = document.getElementsByTagName('script')[0];
  var internalStub = stub || createStub(stubType, stubMethods);

  if (internalStub) {
    if (globalName) window[globalName] = internalStub;
    (globalNames || []).forEach(function (name) {
      window[name] = internalStub;
    });
  }

  script.async = true;
  script.src = src;
  script.type = 'text/javascript';
  if (id) {
    script.id = id;
  }

  var promise = new Promise(function (resolve, reject) {
    script.onerror = function () {
      var error = 'Error loading ' + src;

      _logger2.default.debug(error);
      if (internalStub && internalStub._onError) {
        internalStub._onError(error);
      }

      if (callback) {
        callback(error);
      }

      reject(error);
    };

    script.onload = function () {
      _logger2.default.debug(src + ' loaded successfully');
      if (internalStub && internalStub._onLoad) {
        internalStub._onLoad(window[globalName || globalNames[0]]);
      }

      if (callback) {
        callback(null, window[globalName || globalNames[0]]);
      }

      resolve(window[globalName || globalNames[0]]);
    };
  });

  first.parentNode.insertBefore(script, first);

  return promise;
}

function createStub(stubType, stubMethods) {
  if (stubType === 'function') {
    return createFunctionStub(stubMethods);
  }

  return null;
}

function createFunctionStub(stubMethods) {
  var enqueueCall = function enqueueCall(target, method, args) {
    target._queue = target._queue || [];
    target._queue.push({ method: method, args: args });
    return target;
  };

  var stub = function stub() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return enqueueCall(stub, null, args);
  };

  (stubMethods || []).forEach(function (method) {
    stub[method] = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return enqueueCall(stub, method, args);
    };
  });

  stub._onLoad = function (library) {
    while ((stub._queue || []).length) {
      var call = stub._queue.shift();
      call.method ? library[call.method].apply(library, _toConsumableArray(call.args)) : library.apply(undefined, _toConsumableArray(call.args));
    }
  };

  return stub;
}


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/script-loader.js
// module id = 0
// module chunks = 0